import React from 'react';
import { onLogout } from 'v2/utils/logout';
import { NavLink } from 'react-router-dom';
import styles from './navbar.module.scss';
import SettingsNavLink from './SettingsNavLink';
import classnames from 'classnames';

interface MobileSettingsItemsProps {
  show: boolean;
  showSettings: boolean;
  setExpanded: (expanded: boolean) => void;
}

export const MobileSettingsItems = ({
  show,
  showSettings,
  setExpanded,
}: MobileSettingsItemsProps) =>
  show ? (
    <>
      <SettingsNavLink
        showSettings={showSettings}
        expanded={show}
        onClick={() => setExpanded(false)}
      />
      <NavLink
        className={classnames(
          'nav-link mr-3 mb-2 mb-lg-0',
          styles.navLinks,
          { [styles.navLinkTitle]: show },
          { 'mt-2': show }
        )}
        to="/logout"
        onClick={() => onLogout()}
      >
        Log out
      </NavLink>
    </>
  ) : null;
